import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { MdLogin } from 'react-icons/md';
import { menus } from './Sidebar';
import { userShape } from './ThreadItem';

const BottomNavbar = ({ authUser = null }) => (
  <nav className="fixed bottom-0 left-0 right-0 bg-[hsl(27,90%,97%)] border-t border-[#EAEAEA]">
    <ul className="flex justify-center items-center">
      {menus.map((menu) => (
        <li key={menu.label} className={!authUser ? 'w-1/3' : 'w-1/2'}>
          <NavLink to={menu.to} className="text-center flex flex-col items-center gap-1 py-2.5">
            <menu.icon fontSize={24} />
            <p className="text-sm">{menu.label}</p>
          </NavLink>
        </li>
      ))}
      {!authUser
        && (
        <li className="w-1/3">
          <NavLink to="/login" className="text-center flex flex-col items-center gap-1 py-2.5">
            <MdLogin fontSize={24} />
            <p className="text-sm">Login</p>
          </NavLink>
        </li>
        )}
    </ul>
  </nav>
);

BottomNavbar.propTypes = {
  /** The identity of auth user */
  authUser: PropTypes.shape(userShape),
};

BottomNavbar.defaultProps = {
  authUser: null,
};

export default BottomNavbar;
